var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { class: ((_obj = {}), (_obj[_vm.className] = true), _obj) },
    [_vm._v(_vm._s(_vm.seperateWithCommas(_vm.price)))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }